<div
  #menu
  class="atlas-navbar__transition atlas-navbar__menu"
  [class.atlas-navbar__menu--open]="isOpen()"
  [class.atlas-navbar__menu--closed]="!isOpen()"
>
  <ng-content></ng-content>
</div>
